import { inject, Injectable } from '@angular/core';
import { Maybe } from '@orderna/admin-panel/src/types/maybe';
import { QueryOptions } from '@orderna/admin-panel/src/types/query-options';
import {
  Data,
  deleteItem,
  deleteItems,
  updateItem,
} from '@orderna/admin-panel/src/utils/service';
import { BehaviorSubject, Observable } from 'rxjs';
import { CUSTOMERS } from '../../data/customers';
import {
  Customer,
  CustomerUpdateData,
  ICustomer,
} from '../../model/customer';
import { TransactionsApiService } from '../transactions/transactions-api.service';
import { ICustomersApiService } from './customers-api.interface';
import { FindCustomerPosSummaryResponseDto } from './dtos/find-customer-pos-summary.response.dto';
import { FindCustomerBnpcStatusResponseDto } from './dtos/find-customer-bnpc-status.response.dto';
import { CreateCustomerRequestDto } from './dtos/create-customer.request.dto';
import { CreateCustomerResponseDto } from './dtos/create-customer.response.dto';

@Injectable({
  providedIn: 'root',
})
export class CustomersMockApiService implements ICustomersApiService {
  transactionsService = inject(TransactionsApiService);
  data = {
    customers: {
      items: [...CUSTOMERS],
      queryOptions: { page: 1, size: 10 } as QueryOptions<ICustomer>,
      subject: new BehaviorSubject<Maybe<Customer[]>>(null),
      totalSubject: new BehaviorSubject<Maybe<number>>(null),
      totalAfterFilterSubject: new BehaviorSubject<Maybe<number>>(null),
    },
  };

  get customersData() {
    return this.data['customers'] as Data<Customer, ICustomer>;
  }

  createCustomer(data: CreateCustomerRequestDto): Promise<CreateCustomerResponseDto> {
    throw new Error('Method not implemented.');
  } 

  updateCustomer(customer: CustomerUpdateData): Observable<ICustomer> {
    return updateItem(this.customersData, customer);
  }

  deleteCustomer(customerId: Customer['id']): Observable<ICustomer> {
    return deleteItem(this.customersData, customerId);
  }

  deleteCustomers(customerIds: Customer['id'][]): Observable<ICustomer[]> {
    return deleteItems(this.customersData, customerIds);
  }

  findCustomerPosSummary(customerId: number): Promise<FindCustomerPosSummaryResponseDto> {
    throw new Error('Method not implemented.');
  }

  findCustomerBnpcStatus(customerId: number): Promise<FindCustomerBnpcStatusResponseDto> {
    throw new Error('Method not implemented.');
  }

  getCustomer(customerId: ICustomer['id']): Observable<Maybe<Customer>> {
    throw new Error('Method not implemented.');
  }
}
